// ЕДИНЫЙ конфиг цветов сайта — палитра «Bedtime».
// Меняйте значения только здесь. Подхватывается:
//   • Tailwind  — tailwind.config.js (классы bg-primary, text-ink, brand-* и т.д.)
//   • CSS-формы — applyTheme.js прокидывает значения в CSS-переменные --c-* для index.css

export const COLORS = {
    // ── Основная палитра ──
    primary: '#5A4FF3',       // глубокий индиго (основной)
    primaryHover: '#4A3DE0',  // тёмнее — ховер
    secondary: '#8B7CFF',     // лавандово-синий
    accent: '#9FD7FF',        // нежно-голубой
    bg: '#F6F9FF',            // очень светлый фон страницы
    card: '#FCFDFF',          // фон карточек (холодный белый)
    ink: '#1E2351',           // основной текст (тёмно-синий)
    muted: '#6F78A8',         // второстепенный текст (серо-синий)
    border: '#E4EAFF',        // светло-голубые границы

    // ── Доп. акценты (иллюстрации) ──
    stars: '#FFD76B',
    moon: '#FFE8A3',
    glow: '#D8CFFF',
    clouds: '#EEF3FF',

    // ── Состояния ──
    success: '#55C98D',
    error: '#FF6A7C',
    info: '#78B9FF',

    // ── Градиенты (стопы) ──
    gradients: {
        cta: ['#5A4FF3', '#7A6BFF'],            // основной CTA
        hero: ['#FFFFFF', '#EEF4FF', '#E3ECFF'], // мягкий фон героя
        night: ['#1B2254', '#3346A3', '#6E86FF'], // ночная иллюстрация
    },

    // ── Производные оттенки (выделенные состояния формы) ──
    primaryTint: '#EEF0FF',     // фон выбранного чипа / опции
    primaryTintText: '#4A3DE0', // текст выбранного чипа
    inkSoft: '#3A4275',         // тень «толстых» кнопок
};
